import React, { useState, useEffect } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { CheckCircle, XCircle, Loader } from "lucide-react";
import { authAPI } from "../../services/api";
import BackgroundWrapper from "../../components/common/BackgroundWrapper";
import "./Auth.css";

const VerifyEmail = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("verifying"); // 'verifying', 'success', 'error'
  const [message, setMessage] = useState("");

  useEffect(() => {
    verifyEmail();
  }, [token]);

  const verifyEmail = async () => {
    try {
      const response = await authAPI.verifyEmail(token);

      if (response.data.success) {
        setStatus("success");
        setMessage(response.data.message || "Email verified successfully!");

        // Auto-redirect to login after 3 seconds
        setTimeout(() => {
          navigate("/login", {
            state: { message: "Email verified! Please sign in." },
          });
        }, 3000);
      }
    } catch (error) {
      console.error("Verification error:", error);
      setStatus("error");
      setMessage(
        error.response?.data?.message ||
          "Failed to verify email. The link may be invalid or expired."
      );
    }
  };

  return (
    <BackgroundWrapper background="/auth-grid.png">
      <div className="auth-wrapper">
        <div className="auth-card">
          {/* VERIFYING STATE */}
          {status === "verifying" && (
            <>
              <div className="auth-success-icon">
                <Loader size={60} className="spinning" />
              </div>

              <h2 className="auth-title-small">Verifying Email</h2>
              <p className="auth-subtext">
                Please wait while we verify your email address...
              </p>
            </>
          )}

          {/* SUCCESS STATE */}
          {status === "success" && (
            <>
              <div className="auth-success-icon">
                <CheckCircle size={60} color="#16a34a" />
              </div>

              <h2 className="auth-title-small">Email Verified!</h2>
              <p className="auth-subtext">{message}</p>
              <p className="auth-subtext" style={{ marginTop: "-10px" }}>
                Redirecting to login...
              </p>
            </>
          )}

          {/* ERROR STATE */}
          {status === "error" && (
            <>
              <div className="auth-success-icon">
                <XCircle size={60} color="#dc2626" />
              </div>

              <h2 className="auth-title-small">Verification Failed</h2>
              <p className="auth-subtext">{message}</p>

              <div className="auth-success-actions">
                <Link to="/login">
                  <button className="auth-submit">Go to Login</button>
                </Link>

                <Link to="/register">
                  <button
                    className="auth-submit"
                    style={{ background: "#fff", marginTop: "10px" }}
                  >
                    Create New Account
                  </button>
                </Link>
              </div>
            </>
          )}
        </div>
      </div>
    </BackgroundWrapper>
  );
};

export default VerifyEmail;
